import { AppConfigArea } from 'enums';

import { ConfigsPageTab } from '../ConfigsPageTab';

export const PayinOrdersTab: React.FC = () => (
  <ConfigsPageTab area={AppConfigArea.PayinOrders} />
);
